import { TypeRoutes } from './types';
import MyInformation from '../pages/my_information';
import { IoDocumentTextSharp, IoHomeOutline } from 'react-icons/io5';
import SearchArbitrators from '../pages/search_arbitrators';
import HomePage from '../pages/Home';
import FindArbirators from '../pages/find_arbirators';
import LoginPage from '../pages/login';
import RegisterPage from '../pages/register';
import ArbitralOrders from '../pages/arbitral_orders';
import AdminstrativeOffice from '../pages/adminstrative_office';
import Contact from '../pages/contact';
import Calculator from '../pages/calculator';
import MyApplication from '../pages/my_application';
import ArbitratorView from '../pages/find_arbirators/view';
import HelpSupport from '../pages/help_support';
import { GoHome } from "react-icons/go";
import { VscLaw } from 'react-icons/vsc';
import { RiMailSendFill } from 'react-icons/ri';
import { FaQuestionCircle, FaVideo } from 'react-icons/fa';
import { CgCommunity } from "react-icons/cg";
import { GrSystem } from "react-icons/gr";
import { MdSupportAgent } from 'react-icons/md';
import { HiDocumentPlus } from 'react-icons/hi2';
import SavedApplication from '../pages/saved_application';
import Mediation from '../pages/mediation';
import Services from '../pages/profile_services';
import Settings from '../pages/settings';
import statistics from '../pages/statistics';
import VideoCommunication from '../pages/video_communication';
import ForgotPassword from '../pages/change_password';
import EnterEmail from '../pages/change_password/enter_email';
import EnterCode from '../pages/change_password/enter_code';
import Instruction from '../pages/instruction';

export const _routes: Array<TypeRoutes> = [
	{
		name: 'Home',
		path: '/',
		component: HomePage,
		config: {
			permission: '*',
			icon: IoHomeOutline,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Login',
		path: '/login',
		component: LoginPage,
		config: {
			permission: '*',
			icon: IoHomeOutline,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Register',
		path: '/register',
		component: RegisterPage,
		config: {
			permission: '*',
			icon: IoHomeOutline,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Forgot Password',
		path: '/forgot_password',
		component: ForgotPassword,
		config: {
			permission: '*',
			icon: IoHomeOutline,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Enter Code',
		path: '/enter_code',
		component: EnterCode,
		config: {
			permission: '*',
			icon: IoHomeOutline,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Enter Email',
		path: '/enter_email',
		component: EnterEmail,
		config: {
			permission: '*',
			icon: IoHomeOutline,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: "About us",
		path: "/about-center",
		component: "",
		config: {
			permission: '*',
			icon: IoHomeOutline,
			structure: 'extraLayout',
			isMenu: true,
		},
		submenu: [
			{
				name: 'Adminstrative Office',
				path: '/adminstrative-office',
				component: AdminstrativeOffice,
				config: {
					permission: '*',
					icon: IoHomeOutline,
					structure: 'extraLayout',
					isMenu: true,
				},
				submenu: [],
			},
		],
	},
	{
		name: "Arbitration",
		path: "/adminstrative-office",
		component: "",
		config: {
			permission: '*',
			icon: IoHomeOutline,
			structure: 'extraLayout',
			isMenu: true,
		},
		submenu: [
			{
				name: 'Calculator',
				path: '/calculator',
				component: Calculator,
				config: {
					permission: '*',
					icon: IoHomeOutline,
					structure: 'extraLayout',
					isMenu: true,
				},
				submenu: [],
			},
		],
	},
	{
		name: "Mediation",
		path: "/med-agreement",
		component: "",
		config: {
			permission: '*',
			icon: IoHomeOutline,
			structure: 'extraLayout',
			isMenu: true,
		},
		submenu: []
	},
	{
		name: "Arbitrators",
		path: "/recomended-arbitrators",
		component: "",
		config: {
			permission: '*',
			icon: IoHomeOutline,
			structure: 'extraLayout',
			isMenu: true,
		},
		submenu: [
			{
				name: 'Find arbitrators',
				path: '/find-arbitrators',
				component: FindArbirators,
				config: {
					permission: '*',
					icon: IoHomeOutline,
					structure: 'extraLayout',
					isMenu: true,
				},
				submenu: [],
			},
			{
				name: 'Arbitrator View',
				path: '/find-arbitrators/:id',
				component: ArbitratorView,
				config: {
					permission: '*',
					icon: IoHomeOutline,
					structure: 'extraLayout',
					isMenu: false,
				},
				submenu: [],
			},
			{
				name: 'Arbitral awards and orders',
				path: '/arbitral-orders',
				component: ArbitralOrders,
				config: {
					permission: '*',
					icon: IoHomeOutline,
					structure: 'extraLayout',
					isMenu: true,
				},
				submenu: [],
			},
		]
	},
	{
		name: 'Contact',
		path: '/contact-us',
		component: Contact,
		config: {
			permission: '*',
			icon: IoHomeOutline,
			structure: 'extraLayout',
			isMenu: true,
		},
		submenu: [],
	},
];

export const sidebar_routes: Array<TypeRoutes> = [
	{
		name: 'My information',
		path: '/my-information',
		component: MyInformation,
		config: {
			permission: '*',
			icon: GoHome,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Applications',
		path: "/asasasasas",
		component: "",
		config: {
			permission: '*',
			icon: RiMailSendFill,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [
			{
				name: 'My Application',
				path: '/my-application',
				component: MyApplication,
				config: {
					permission: '*',
					icon: IoDocumentTextSharp,
					structure: 'layout',
					isMenu: true,
				},
			},
			{
				name: 'Calculator',
				path: '/profile-calcultor',
				component: Calculator,
				config: {
					permission: '*',
					icon: RiMailSendFill,
					structure: 'layout',
					isMenu: true,
				},
			},
			{
				name: 'Saved application',
				path: '/saved-application',
				component: SavedApplication,
				config: {
					permission: '*',
					icon: IoDocumentTextSharp,
					structure: 'layout',
					isMenu: true,
				},
			},
		],
	},
	{
		name: 'Arbitration',
		path: "",
		component: "",
		config: {
			permission: '*',
			icon: VscLaw,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [
			{
				name: 'Search arbitrators',
				path: '/search-arbitrators',
				component: SearchArbitrators,
				config: {
					permission: '*',
					icon: VscLaw,
					structure: 'layout',
					isMenu: true,
				},
				submenu: [],
			},
		],
	},
	{
		name: 'Mediation',
		path: '/mediation',
		component: Mediation,
		config: {
			permission: '*',
			icon: FaVideo,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Services',
		path: '/services',
		component: Services,
		config: {
			permission: '*',
			icon: CgCommunity,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Settings',
		path: '/settings',
		component: Settings,
		config: {
			permission: '*',
			icon: FaQuestionCircle,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Video communication',
		path: '/video-communication',
		component: VideoCommunication,
		config: {
			permission: '*',
			icon: FaQuestionCircle,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Statistics',
		path: '/statistics',
		component: statistics,
		config: {
			permission: '*',
			icon: GrSystem,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Support',
		path: '/support',
		component: HelpSupport,
		config: {
			permission: '*',
			icon: MdSupportAgent,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
	{
		name: 'Instruction',
		path: '/instruction',
		component: Instruction,
		config: {
			permission: '*',
			icon: MdSupportAgent,
			structure: 'layout',
			isMenu: true,
		},
		submenu: [],
	},
];




// #########################################################

